import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import AppHeader from '../components/AppHeader.js';
import Search from '../components/Search.js';
import LinksNew from '../components/LinksNew.js';
import LinksEdit from '../components/LinksEdit.js';
import clipboard from '../utils/clipboard.js';

const getGroupBadge = (groupName) => {
	const trimmedGroupName = (groupName || '').trim();

	if (trimmedGroupName === '') {
		return 'SK';
	}

	return trimmedGroupName.slice(0, 2).toUpperCase();
};

export default function Links({usrInfo, timerCnt}) {
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState([]);
	const [dataDetail, setDataDetail] = useState({});
	const [showNew, setShowNew] = useState(false);
	const [showEdit, setShowEdit] = useState(false);
	const [searchValue, setSearchValue] = useState('');

	useEffect(() => {
		getData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onChangeSearch = (value) => {
		setSearchValue(value);
	};

	const getData = () => {
		setLoading(true);

		post('getListLinks', {search: ''})
			.then((res) => {
				setData(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	const handleNew = () => {
		setShowNew(true);
	};

	const closeNew = () => {
		setShowNew(false);
	};

	const updateLinksRowNew = (row) => {
		setData([row, ...data]);
	};

	const handleEdit = (rec) => {
		setShowEdit(true);
		setDataDetail(rec);
	};

	const closeEdit = () => {
		setShowEdit(false);
	};

	const updateLinksRowEdit = (row) => {
		const newData = data.map((item) => {
			if (item.ID === row.ID) {
				item.NAME = row.NAME;
				item.URL = row.URL;
				item.GROUPNAME = row.GROUPNAME;
			}

			return item;
		});

		setData(newData);
	};

	const updateLinksRowDelete = (row) => {
		const newData = data.filter((item) => {
			return item.ID !== row;
		});

		setData(newData);
	};

	const handleOpenUrl = (url) => {
		if (!url || typeof window === 'undefined') {
			return;
		}

		window.open(url, '_blank', 'noopener,noreferrer');
	};

	const search = searchValue.trim().toLowerCase();
	const filteredData =
		search === ''
			? data
			: data.filter((item) => {
					const name = (item.NAME || '').toLowerCase();
					const url = (item.URL || '').toLowerCase();

					return name.includes(search) || url.includes(search);
				});

	const groups = [];
	let currentGroup = null;

	filteredData.forEach((item, index) => {
		const previousGroupName = index === 0 ? '' : filteredData[index - 1].GROUPNAME;
		const groupName = item.GROUPNAME || 'Bez skupiny';

		if (index === 0 || groupName !== previousGroupName) {
			currentGroup = {
				key: `group_${groupName}_${index}`,
				name: groupName,
				items: [],
			};

			groups.push(currentGroup);
		}

		currentGroup.items.push(item);
	});

	return (
		<>
			<div className="page_main">
				<AppHeader usrInfo={usrInfo} timerCnt={timerCnt} loading={loading} />
				<Search showNew handleNew={handleNew} showSearch searchValue={searchValue} onChangeSearch={(e) => onChangeSearch(e)} debounceMs={0} />
				<LinksNew showNew={showNew} closeNew={closeNew} updateLinksRowNew={updateLinksRowNew} />
				<LinksEdit showEdit={showEdit} closeEdit={closeEdit} updateLinksRowEdit={updateLinksRowEdit} updateLinksRowDelete={updateLinksRowDelete} data={dataDetail} />

				<div className={`page links-page${usrInfo.sysAdmin === 1 || usrInfo.manager === 1 || usrInfo.instructor === 1 ? ' more' : ''}`}>
					<div className="links-page__sections">
						{groups.length > 0 ? (
							groups.map((group) => (
								<section className="links-page__section" key={group.key}>
									<div className="links-page__group">
										<div className="links-page__group-badge">{getGroupBadge(group.name)}</div>
										<div className="links-page__group-text">
											<span className="links-page__group-label">Skupina odkazů</span>
											<span className="links-page__group-name" dangerouslySetInnerHTML={{__html: group.name}}></span>
										</div>
									</div>
									<div className="links-page__list">
										{group.items.map((item, index) => {
											const hasUrl = (item.URL || '').trim() !== '';

											return (
												<div
													className={`links-page__row${hasUrl ? ' is-clickable' : ''}${hasUrl ? '' : ' is-muted'}`}
													key={`row_${item.ID || group.key}_${index}`}
													onClick={hasUrl ? () => handleOpenUrl(item.URL) : undefined}
													onKeyDown={
														hasUrl
															? (event) => {
																	if (event.key === 'Enter' || event.key === ' ') {
																		event.preventDefault();
																		handleOpenUrl(item.URL);
																	}
																}
															: undefined
													}
													role={hasUrl ? 'link' : undefined}
													tabIndex={hasUrl ? 0 : undefined}
												>
													<div className="links-page__row-main">
														<div className="links-page__row-name">
															<span className="links-page__row-label" dangerouslySetInnerHTML={{__html: item.NAME}}></span>
														</div>
													</div>
													<div className="links-page__row-actions">
														{hasUrl && (
															<button
																type="button"
																className="links-page__icon-button"
																onClick={(event) => {
																	event.stopPropagation();
																	clipboard(item.URL);
																}}
																aria-label="Kopírovat odkaz"
															>
																<img className="icon1 copy" alt="" />
															</button>
														)}
														<button
															type="button"
															className="links-page__icon-button"
															onClick={(event) => {
																event.stopPropagation();
																handleEdit(item);
															}}
															aria-label="Upravit odkaz"
														>
															<img className="icon1 edit" alt="" />
														</button>
													</div>
												</div>
											);
										})}
									</div>
								</section>
							))
						) : (
							<div className="links-page__empty">Žádné odkazy nebyly nalezeny.</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
}
